import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Base\Admin\ServerController::about
* @see app/Http/Controllers/Base/Admin/ServerController.php:21
* @route '/admin/servers/{server}'
*/
export const about = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(args, options),
    method: 'get',
})

about.definition = {
    methods: ["get","head"],
    url: '/admin/servers/{server}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Base\Admin\ServerController::about
* @see app/Http/Controllers/Base/Admin/ServerController.php:21
* @route '/admin/servers/{server}'
*/
about.url = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { server: args }
    }

    if (Array.isArray(args)) {
        args = {
            server: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        server: args.server,
    }

    return about.definition.url
            .replace('{server}', parsedArgs.server.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Base\Admin\ServerController::about
* @see app/Http/Controllers/Base/Admin/ServerController.php:21
* @route '/admin/servers/{server}'
*/
about.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\ServerController::about
* @see app/Http/Controllers/Base/Admin/ServerController.php:21
* @route '/admin/servers/{server}'
*/
about.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: about.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Base\Admin\ServerController::about
* @see app/Http/Controllers/Base/Admin/ServerController.php:21
* @route '/admin/servers/{server}'
*/
const aboutForm = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: about.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\ServerController::about
* @see app/Http/Controllers/Base/Admin/ServerController.php:21
* @route '/admin/servers/{server}'
*/
aboutForm.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: about.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\ServerController::about
* @see app/Http/Controllers/Base/Admin/ServerController.php:21
* @route '/admin/servers/{server}'
*/
aboutForm.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: about.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

about.form = aboutForm

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDetailsController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDetailsController.php:11
* @route '/admin/servers/{server}/details'
*/
export const details = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: details.url(args, options),
    method: 'get',
})

details.definition = {
    methods: ["get","head"],
    url: '/admin/servers/{server}/details',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDetailsController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDetailsController.php:11
* @route '/admin/servers/{server}/details'
*/
details.url = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { server: args }
    }

    if (Array.isArray(args)) {
        args = {
            server: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        server: args.server,
    }

    return details.definition.url
            .replace('{server}', parsedArgs.server.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDetailsController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDetailsController.php:11
* @route '/admin/servers/{server}/details'
*/
details.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: details.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDetailsController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDetailsController.php:11
* @route '/admin/servers/{server}/details'
*/
details.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: details.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDetailsController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDetailsController.php:11
* @route '/admin/servers/{server}/details'
*/
const detailsForm = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: details.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDetailsController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDetailsController.php:11
* @route '/admin/servers/{server}/details'
*/
detailsForm.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: details.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDetailsController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDetailsController.php:11
* @route '/admin/servers/{server}/details'
*/
detailsForm.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: details.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

details.form = detailsForm

/**
* @see \App\Http\Controllers\Base\Admin\GetServerBuildController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerBuildController.php:11
* @route '/admin/servers/{server}/build'
*/
export const build_configuration = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: build_configuration.url(args, options),
    method: 'get',
})

build_configuration.definition = {
    methods: ["get","head"],
    url: '/admin/servers/{server}/build',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Base\Admin\GetServerBuildController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerBuildController.php:11
* @route '/admin/servers/{server}/build'
*/
build_configuration.url = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { server: args }
    }

    if (Array.isArray(args)) {
        args = {
            server: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        server: args.server,
    }

    return build_configuration.definition.url
            .replace('{server}', parsedArgs.server.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Base\Admin\GetServerBuildController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerBuildController.php:11
* @route '/admin/servers/{server}/build'
*/
build_configuration.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: build_configuration.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerBuildController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerBuildController.php:11
* @route '/admin/servers/{server}/build'
*/
build_configuration.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: build_configuration.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerBuildController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerBuildController.php:11
* @route '/admin/servers/{server}/build'
*/
const build_configurationForm = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: build_configuration.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerBuildController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerBuildController.php:11
* @route '/admin/servers/{server}/build'
*/
build_configurationForm.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: build_configuration.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerBuildController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerBuildController.php:11
* @route '/admin/servers/{server}/build'
*/
build_configurationForm.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: build_configuration.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

build_configuration.form = build_configurationForm

/**
* @see \App\Http\Controllers\Base\Admin\GetServerStartupController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerStartupController.php:11
* @route '/admin/servers/{server}/startup'
*/
export const startup = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: startup.url(args, options),
    method: 'get',
})

startup.definition = {
    methods: ["get","head"],
    url: '/admin/servers/{server}/startup',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Base\Admin\GetServerStartupController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerStartupController.php:11
* @route '/admin/servers/{server}/startup'
*/
startup.url = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { server: args }
    }

    if (Array.isArray(args)) {
        args = {
            server: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        server: args.server,
    }

    return startup.definition.url
            .replace('{server}', parsedArgs.server.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Base\Admin\GetServerStartupController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerStartupController.php:11
* @route '/admin/servers/{server}/startup'
*/
startup.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: startup.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerStartupController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerStartupController.php:11
* @route '/admin/servers/{server}/startup'
*/
startup.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: startup.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerStartupController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerStartupController.php:11
* @route '/admin/servers/{server}/startup'
*/
const startupForm = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: startup.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerStartupController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerStartupController.php:11
* @route '/admin/servers/{server}/startup'
*/
startupForm.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: startup.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerStartupController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerStartupController.php:11
* @route '/admin/servers/{server}/startup'
*/
startupForm.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: startup.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

startup.form = startupForm

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDatabasesController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDatabasesController.php:11
* @route '/admin/servers/{server}/databases'
*/
export const databases = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: databases.url(args, options),
    method: 'get',
})

databases.definition = {
    methods: ["get","head"],
    url: '/admin/servers/{server}/databases',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDatabasesController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDatabasesController.php:11
* @route '/admin/servers/{server}/databases'
*/
databases.url = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { server: args }
    }

    if (Array.isArray(args)) {
        args = {
            server: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        server: args.server,
    }

    return databases.definition.url
            .replace('{server}', parsedArgs.server.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDatabasesController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDatabasesController.php:11
* @route '/admin/servers/{server}/databases'
*/
databases.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: databases.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDatabasesController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDatabasesController.php:11
* @route '/admin/servers/{server}/databases'
*/
databases.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: databases.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDatabasesController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDatabasesController.php:11
* @route '/admin/servers/{server}/databases'
*/
const databasesForm = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: databases.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDatabasesController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDatabasesController.php:11
* @route '/admin/servers/{server}/databases'
*/
databasesForm.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: databases.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerDatabasesController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerDatabasesController.php:11
* @route '/admin/servers/{server}/databases'
*/
databasesForm.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: databases.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

databases.form = databasesForm

/**
* @see \App\Http\Controllers\Base\Admin\GetServerFirewallController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerFirewallController.php:11
* @route '/admin/servers/{server}/firewall'
*/
export const firewall = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: firewall.url(args, options),
    method: 'get',
})

firewall.definition = {
    methods: ["get","head"],
    url: '/admin/servers/{server}/firewall',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Base\Admin\GetServerFirewallController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerFirewallController.php:11
* @route '/admin/servers/{server}/firewall'
*/
firewall.url = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { server: args }
    }

    if (Array.isArray(args)) {
        args = {
            server: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        server: args.server,
    }

    return firewall.definition.url
            .replace('{server}', parsedArgs.server.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Base\Admin\GetServerFirewallController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerFirewallController.php:11
* @route '/admin/servers/{server}/firewall'
*/
firewall.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: firewall.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerFirewallController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerFirewallController.php:11
* @route '/admin/servers/{server}/firewall'
*/
firewall.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: firewall.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerFirewallController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerFirewallController.php:11
* @route '/admin/servers/{server}/firewall'
*/
const firewallForm = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: firewall.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerFirewallController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerFirewallController.php:11
* @route '/admin/servers/{server}/firewall'
*/
firewallForm.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: firewall.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerFirewallController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerFirewallController.php:11
* @route '/admin/servers/{server}/firewall'
*/
firewallForm.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: firewall.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

firewall.form = firewallForm

/**
* @see \App\Http\Controllers\Base\Admin\GetServerAdvancedController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerAdvancedController.php:11
* @route '/admin/servers/{server}/advanced'
*/
export const advanced = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: advanced.url(args, options),
    method: 'get',
})

advanced.definition = {
    methods: ["get","head"],
    url: '/admin/servers/{server}/advanced',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Base\Admin\GetServerAdvancedController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerAdvancedController.php:11
* @route '/admin/servers/{server}/advanced'
*/
advanced.url = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { server: args }
    }

    if (Array.isArray(args)) {
        args = {
            server: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        server: args.server,
    }

    return advanced.definition.url
            .replace('{server}', parsedArgs.server.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Base\Admin\GetServerAdvancedController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerAdvancedController.php:11
* @route '/admin/servers/{server}/advanced'
*/
advanced.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: advanced.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerAdvancedController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerAdvancedController.php:11
* @route '/admin/servers/{server}/advanced'
*/
advanced.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: advanced.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerAdvancedController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerAdvancedController.php:11
* @route '/admin/servers/{server}/advanced'
*/
const advancedForm = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: advanced.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerAdvancedController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerAdvancedController.php:11
* @route '/admin/servers/{server}/advanced'
*/
advancedForm.get = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: advanced.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Base\Admin\GetServerAdvancedController::__invoke
* @see app/Http/Controllers/Base/Admin/GetServerAdvancedController.php:11
* @route '/admin/servers/{server}/advanced'
*/
advancedForm.head = (args: { server: string | number } | [server: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: advanced.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

advanced.form = advancedForm

const manage = {
    about: Object.assign(about, about),
    details: Object.assign(details, details),
    build_configuration: Object.assign(build_configuration, build_configuration),
    startup: Object.assign(startup, startup),
    databases: Object.assign(databases, databases),
    firewall: Object.assign(firewall, firewall),
    advanced: Object.assign(advanced, advanced),
}

export default manage